import React, { useMemo } from 'react'
import { baseRowStyle } from './CollateralBasketDialogUtils'
import { TradingEntityDetail } from 'api'
import {
  AgGridWrapper,
  TypedValueGetterParams,
  gridOptionsBase,
  StatusCellRenderer,
  filteredColumnDefsBuilder
} from 'view/components/datagrid'
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community'
import { Locale, Translation } from 'locale'
import { getEntityStatusColor } from '../datagrid'
import { DeleteButtonRenderer } from '../../components/datagrid/renderers/DeleteButtonRenderer'

interface CollateralBasketSelectedPermissionsGridProps {
  rowData: TradingEntityDetail[]
  onRemoveTradingEntityId: (tradingEntityIds: string[]) => void
  viewOnly: boolean
}

const columnDef: (ColDef | ColGroupDef)[] = [
  {
    colId: 'ORGANISATION_NAME',
    valueGetter: (params: TypedValueGetterParams<TradingEntityDetail>) => params.data?.organisation?.legalName,
    headerName: Locale.translate(Translation.TC_ORGANISATION),
    resizable: false,
    cellRenderer: StatusCellRenderer,
    cellRendererParams: {
      getStatusColor: (data: TradingEntityDetail) => getEntityStatusColor(data.tradingEntity.status),
      isBorderRadius: true
    }
  },
  {
    colId: 'ENTITY_NAME',
    valueGetter: (params: TypedValueGetterParams<TradingEntityDetail>) => params.data?.tradingEntity.publishedName,
    headerName: Locale.translate(Translation.TC_ENTITY),
    resizable: false
  },
  {
    colId: 'DELETE_ENTITY',
    width: 40,
    minWidth: 40,
    cellRenderer: DeleteButtonRenderer,
    cellStyle: {
      borderLeft: '1px solid #e1e3e7'
    },
    resizable: false
  }
]

const gridOptions: GridOptions = {
  ...gridOptionsBase,
  getRowId: ({ data }) => data.tradingEntity.id,
  rowStyle: baseRowStyle
}

export const CollateralBasketSelectedPermissionsGrid: React.FunctionComponent<CollateralBasketSelectedPermissionsGridProps> = props => {
  const { rowData, onRemoveTradingEntityId, viewOnly } = props

  const handleDelete = (_rowId: string, rowItem: TradingEntityDetail, _updatedField: string) => {
    onRemoveTradingEntityId([rowItem.tradingEntity.id])
  }

  const filteredColumnDefs = useMemo(
    () =>
      filteredColumnDefsBuilder(columnDef)
        .withoutIf(viewOnly, ['DELETE_ENTITY'])
        .build(),
    [viewOnly]
  )

  return (
    <AgGridWrapper
      className="datagrid-borderless"
      gridOptions={gridOptions}
      columnDefs={filteredColumnDefs}
      rowData={rowData}
      onCellValueUpdated={handleDelete}
    />
  )
}
